<template>
  <BittsFilterSelect
    v-model="model"
    :options="operatorOptions"
    :use-search="false"
    :disabled="isDisabled"
    placeholder="Select operator"
  />
</template>

<script setup lang="ts">
import { BittsFilterSelect } from '@crossbeam/bitts';

import { computed } from 'vue';

import { getOperatorsForDataType } from '@/constants/filter-operators';
import type { ReportFilterOperatorTypes } from '@/types/filters';
import type { SourceDataType } from '@/types/sources';

const props = withDefaults(
  defineProps<{
    dataType: SourceDataType;
    disabled?: boolean;
    /** If provided, only show these operators */
    allowedOperators?: ReportFilterOperatorTypes[];
  }>(),
  {
    disabled: false,
    allowedOperators: undefined,
  },
);

const model = defineModel<ReportFilterOperatorTypes>();

const operatorOptions = computed(() => {
  const configs = getOperatorsForDataType(props.dataType);
  const { allowedOperators } = props;
  const filtered = allowedOperators
    ? configs.filter((c) => allowedOperators.includes(c.operator))
    : configs;
  return filtered.map((config) => ({
    label: config.label,
    value: config.operator,
  }));
});

const isDisabled = computed(
  () => props.disabled || operatorOptions.value.length <= 1,
);
</script>
